import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  padding-top: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;
